import { FocusEvent, useCallback } from 'react';

/**
 * Tab 으로 영역 바깥에 포커스가 나갔을 때만 닫는 onBlur 핸들러 생성.
 * 마우스 blur(relatedTarget=null)는 무시 — ClickAwayListener 등 다른 메커니즘에 위임.
 */
const useTabOutClose = <T extends HTMLElement = HTMLElement>(
  isOpen: boolean,
  onClose: () => void,
) =>
  useCallback(
    (e: FocusEvent<T>) => {
      if (!isOpen) return;
      const next = e.relatedTarget as Node | null;
      if (!next) return;
      if (e.currentTarget.contains(next)) return;
      onClose();
    },
    [isOpen, onClose],
  );

export default useTabOutClose;
